<template>
	<div class="MainBox">
    <div class="TableHead" v-if="rootid.length < 24">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="GoToPage('DealerEdit?type=add')"><span class="icon iconfont iconicon-test20"></span>{{$t('b.Dealer.AddDealer')}}</li>
        <li v-if="!userType(3)" class="TableHeadLeftRow btnStyleTwo cyanBackColor btnRadius">
          <span class="icon iconfont iconicon-test19"></span>{{$t('c.Common.DatasImport')}}
          <input type="file" class="upload" @change="UploadFile" ref="file" />
        </li>
        <li class="TableHeadLeftRow btnStyleTwo greenBackColor btnRadius" @click="HandleModel(true, 1)"><span
            class="icon iconfont iconicon-test3"></span>库存录入</li>
      </ul>
      <ul class="TableHeadRight">
        <div class="SearchBox">
          <input :placeholder="$t('b.Dealer.HintOne')" v-model="QueryName" v-on:keyup.13="QueryData" />
          <a class="SearchBtn" @click="QueryData" v-text="$t('c.Common.Search')"></a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <viewer @inited="inited" ref="viewer">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th v-text="$t('c.Common.Name')"></th>
            <th v-text="$t('c.Common.Alias')"></th>
            <th v-text="$t('c.Common.Image')"></th>
            <th v-text="$t('c.Common.Linkman')"></th>
            <th v-text="$t('c.Common.Phone')"></th>
            <th v-text="$t('c.Common.Address')"></th>
            <th v-text="$t('c.Common.CreationTime')"></th>
            <th v-text="$t('c.Common.Operation')"></th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-text="item.name"></td>
            <td v-text="item.alias"></td>
            <td>
              <div class="tableImg backImg" :style="{backgroundImage: 'url(' + item.cover_img + ')'}" v-if="item.cover_img"><img v-if="item.cover_img" class="tableImgShow" :src="item.cover_img" @click="PreviewImgs"></div>
              <div class="tableImg backImg backImgNull" v-else></div>
            </td>
            <td v-text="item.linkman"></td>
            <td v-text="item.linkphone"></td>
            <td v-text="item.linkaddress"></td>
            <td v-text="item.created_at"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius blueBackColor" @click="GoURL('DealerEdit',item.rootid,item.rootid_extid1,item.rootid_extid2,item.rootid_extid3)" v-text="$t('c.Common.Edit')"></a>
                <a class="btnStyleTwo btnRadius cyanBackColor"  @click="GoURL('UserManage',item.rootid,item.rootid_extid1,item.rootid_extid2,item.rootid_extid3)" v-text="$t('c.Common.Manage')"></a>
                <a v-if="!userType(3)" class="btnStyleTwo btnRadius greenBackColor" @click="GoURL('StockManage',item.rootid,item.rootid_extid1,item.rootid_extid2,item.rootid_extid3,item.name)" v-text="$t('c.Common.Stock')"></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </viewer>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- 库存录入窗口 -->
    <div class="ModalBox" v-if="ModelShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          库存录入
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback"
            @click="HandleModel(false, 1)"></span>
        </div>
        <div class="ModalMainBox">
          <ul class="FormStyleTwo">
            <!-- 下来选择5-6为上海红纺定制 -->
            <K-Select 
              v-for="(item,index) in selectList" 
              :key="index" :selectItem="item" 
              :selectIx="index" 
              @selectActive="selectActive"
            ></K-Select>

            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>数量</p>
              <p><input :placeholder="`${selectList[0].ix?'出库':'入库'}数量`" type="number" v-model="num" /></p>
            </li>
          </ul>
        </div>
        <div class="ModalMainFoot">
          <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false, 1)"
              v-text="$t('c.Common.Cancel')"></a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm()" v-text="$t('c.Common.Confirm')"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import $axios from '@/hooks/axios-common.js'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
import SelectView from '@/components/common/SelectView.vue'
export default {
  name: 'DealerManage',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-Select': SelectView
  },
  data () {
    return {
      page:1,
      subHint:'数据加载中...',
      isLoding:true,
      totalPages:0,
      datas:null,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null
      },
      ConfirmType:null,
      QueryName:null,
      num: '',
      ModelShow: false,
      rootid: '',
      selectList: [{
        name:'类型',
        ix: 0,
        active: false,
        type: 'static',
        title: '录入类型',
        hint: '',
        datas: ['入库', '出库'],
        excludeIds: [],
        availableIds: [],
      },{
        name:'等级',
        ix: 0,
        active: false,
        type: 'static',
        title: '码标等级',
        hint: '',
        datas: [1, 2, 3, 4],
        excludeIds: [],
        availableIds: [],
      },{
        name:'产品',
        ix: 0,
        page: 1,
        totalPages: 0,
        active: false,
        search: true,
        listUrl: 'production_list',
        searchUrl: 'production_list_condition',
        title: 'c.Common.Product',
        hint: '',
        datas: [],
        excludeIds: [],
        availableIds: [],
      }, {
        name:'经销商',
        ix: 0,
        page: 1,
        totalPages: 0,
        active: false,
        search: true,
        listUrl: 'dealer_list',
        searchUrl: 'dealer_list_condition',
        title: 'b.Dealer.Dealer',
        hint: '',
        datas: [],
        excludeIds: [],
        availableIds: [],
      }],
    }
  },
  created () {
    self = this;
    self.rootid = localStorage.getItem("wwmxt_Rootid");  //用户ID
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    self.GetList();

    //请求下拉列表数据-产品
    $axios.selectList.call(this,2,"post","production_list_condition",{no_page:true});

    //请求下拉列表数据-经销商
    $axios.selectList.call(this,3,"get","dealer_list");
  },
  methods: {
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"dealer_list/"+self.page)
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;

        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    QueryData () {
      self.datas = null;
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"dealer_list_condition",{name:self.QueryName})
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;

        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    GoEdit (idOne,idTwo,idThree,idFour) {
      self.GoToPage('DealerEdit?id='+self.GoDealerID(idOne,idTwo,idThree,idFour));
    },
    GoURL(url,idOne,idTwo,idThree,idFour,name) {
      if(name){
        var stock = {id:self.GoDealerID(idOne,idTwo,idThree,idFour),type:"dealer",name:name};
        localStorage.setItem("wwmxt_stock",JSON.stringify(stock));
        self.GoToPage(url);
      }else{
        self.GoToPage(url+'?id='+self.GoDealerID(idOne,idTwo,idThree,idFour));
      }
    },
    UploadFile () {
      let fileTxt;
      let size = (this.$refs.file.files[0].size/(1024 * 1024)).toFixed(2);
      if(size < 0.01){
        size = 0.01;
      }
      if(size > 20){
        self.ToastFun(1,"文件大小不能超过20M，当前大小为："+size+"M！");
        fileTxt = null;
        return;
      }
      fileTxt = '（'+size+'M）' + this.$refs.file.files[0].name;
      self.ConfirmType = 2;
      self.Confirm.state = true;
      self.Confirm.txt = "是否确定导入 "+fileTxt+" 文件？"
    },
    ConfirmBackFun (data) {
      self.Confirm.state = data.state;
      if(data.state){
        self.Confirm.state = false;
        self.loading = true;

        let fileDOM;
        fileDOM = this.$refs.file;

        //FormDatas格式提交
        let Datas = new FormData();
        Datas.append("file",fileDOM.files[0]);
        Datas.append("rootid",localStorage.getItem("wwmxt_Rootid"));

        axios.post(self.GetServerUrl(1)+"importUserBy50",Datas)
        .then(function (response){
          self.$refs.file.value = null; //清空input-file
          self.loading = false;
          self.ToastFun(0,response.data.message);
          self.GetList();
        }).catch(function (error){
          self.$refs.file.value = null; //清空input-file
          self.loading = false;
          self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
        })
      }
    },
    HandleModel(status, te) {  //隐藏显示生码模态框
      if (te == 1) {
        self.ModelShow = status;
      }
    },
    selectActive(params){
      this.keyword = params.keyword; //搜索框内容
      if(params.type === 'active'){ //点击展开

        //隐藏所有下拉内容
        self.selectList.forEach((value,index)=>{
          if(index !== params.selectIx) value.active = false;
        })
        //展开、隐藏当前下拉框
        self.selectList[params.selectIx].active = !self.selectList[params.selectIx].active;
      }else if(params.type === 'check'){ //选中属性
        self.selectList[params.selectIx].active = false;
        self.selectList[params.selectIx].ix = params.optionIx;

        //生产日期
        if (params.selectIx == 1 && params.optionIx == 2) {
          self.attribute.ship_date = params.ship_date;
        }
      }else if(params.type === 'search'){ //搜索
        $axios.searchSelectData.call(this,params.selectIx,params.url);
      }else if(params.type === 'more'){ //查看更多
        $axios.selectLoadMore.call(this,params.selectIx,params.url);
      }
    },
    SubmitForm() {  //提交表单
      let ix, Datas, type, level, ProductID, toRootID, RootID;
      const FormRootID = localStorage.getItem("wwmxt_Rootid");
      this.selectList.forEach(item=>{
        if(item.name == "产品"){
          ProductID = item.datas[item.ix].production_id;
        }else if(item.name == "经销商"){
          toRootID = item.datas[item.ix].search_rootid;
        }else if(item.name == "等级"){
          level = item.datas[item.ix];
        }else if(item.name == "类型"){
          type = item.ix;
        }
      });

      Datas = { type, level, etype: -1, change_num: 0, from_rootid: FormRootID, to_rootid: toRootID, production_id: ProductID, number: self.num };
      self.loading = true;
      axios.post(self.GetServerUrl(1) + "manualStock", Datas)
        .then(function (response) {
          self.loading = false;
          self.ModelShow = false;
          self.ToastFun(0, response.data.message);
          self.GetList();
          self.num = '';
        }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2, self.ErrorHint(error));  //弹窗提醒
        })
    }
  }
}
</script>

<style scoped>

</style>
